
import Vue from "vue";
import DashboardInfo from "@/@modules/fseg/components/DashboardInfo.vue";
import FsegLayout from "@/@modules/fseg/components/Layout.vue";
import MaintenanceInfo from "@/@shell/components/MaintenanceInfo/Index.vue";
import ReleaseInfo from "@/@shell/components/ReleaseInfo/Index.vue";

export default Vue.extend({
  components: {
    FsegLayout,
    DashboardInfo,
    MaintenanceInfo,
    ReleaseInfo,
  },
});
